import { makeRequest } from "./api";

export const FetchUsers = async (page, limit) => {
  return makeRequest(
    `/api/admin/host-guest-user/fetchAll?page=${page}&limit=${limit}`
  );
};


export const FetchPendingAccountHolders = async (page, limit) => {
  return makeRequest(
    `/api/admin/host-guest-user/fetchPendingAccountHolders?page=${page}&limit=${limit}`
  );
};


export const ChangeAdminApproval = async (userId, adminApproval) => {
  return makeRequest("/api/admin/host-guest-user/change-admin-approval", {
    method: "PUT",
    data: { userId, adminApproval },
  });
};



export const handleBan = async (userId, banStatus) => {
  return makeRequest("/api/admin/host-guest-user/handleBan", {
    method: "PUT",
    data: {
      userId,
      banStatus,
    },
  });
};

export const handleTestAccount = async (userId, isTestAccount) => {
  return makeRequest("/api/admin/host-guest-user/handleTestAccount", {
    method: "PUT",
    data: {
      userId,
      isTestAccount,
    },
  });
};

export const FetchUser = async (userId) => {
  return makeRequest(`/api/admin/host-guest-user/fetch/${userId}`);
};

export const handleRemove = async (userId, removeStatus) => {
  return makeRequest("/api/admin/host-guest-user/handleRemove", {
    method: "PUT",
    data: { userId, removeStatus },
  });
};

export const DownloadCSV = async () => {
  return makeRequest("/api/admin/host-guest-user/download-csv");
};

export const ExportUsers = async () => {
  return makeRequest("/api/admin/host-guest-user/export");
};

export const SearchRecords = async (keyword, page, limit, role) => {
  const query = new URLSearchParams({
    key: keyword,
    page: String(page),
    limit: String(limit),
    role,
  });
  return makeRequest(`/api/admin/host-guest-user/search?${query}`);
};

export const FetchDeleteRequests = async (page, limit, key = "") => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (key) query.set("key", key);
  return makeRequest(`/api/admin/host-guest-user/delete-requests?${query}`);
};

export const CancelDeleteRequest = async (userId, note) => {
  return makeRequest("/api/admin/host-guest-user/delete-requests/cancel", {
    method: "PUT",
    data: { userId, note },
  });
};

export const AddDeleteRequestConclusion = async (userId, note) => {
  return makeRequest("/api/admin/host-guest-user/delete-requests/conclusion", {
    method: "PUT",
    data: { userId, note },
  });
};

export const FinalizeDeleteRequest = async (userId) => {
  return makeRequest("/api/admin/host-guest-user/delete-requests/finalize", {
    method: "PUT",
    data: { userId },
  });
};
